<script setup lang="ts">
import { computed, toRefs, watchEffect, inject } from 'vue';
// import { useImage } from '@/src/composables/useCurrentImage';
import { useModel } from '@/src/composables/useModel';
// import { useResliceRepresentation } from '@/src/core/vtk/useResliceRepresentation';
import { useWindowingConfig } from '@/src/composables/useWindowingConfig';
import { Maybe } from '@/src/types';
import { VtkViewContext } from '@/src/components/vtk/context';
import { SlabTypes } from '@kitware/vtk.js/Rendering/Core/ImageResliceMapper/Constants';
import type { Vector3, RGBColor } from '@kitware/vtk.js/types';
import { watchImmediate } from '@vueuse/core';
// import vtkPlane from '@kitware/vtk.js/Common/DataModel/Plane';

import { usePolydataRepresentation } from '@/src/core/vtk/usePolydataRepresentation';

import vtkSphereSource from '@kitware/vtk.js/Filters/Sources/SphereSource';


interface Props {
  modelId: string;
  modelDisplay: boolean;
  color: RGBColor;
}

const props = defineProps<Props>();
const { modelId: modelID, modelDisplay, color} = toRefs(props);

const view = inject(VtkViewContext);
if (!view) throw new Error('No VtkView');

const { polydata, metadata } = useModel(modelID);

// bind window configs
// const wlConfig = useWindowingConfig(viewID, imageID);

const polydataRep = usePolydataRepresentation(view, polydata);

polydataRep.actor.getProperty().setColor(metadata.value.color);

const visibility = computed(() => {
  return metadata.value.display;
})

watchEffect(() => {
  polydataRep.actor.setVisibility(visibility.value);
});


// const sphereSource = vtkSphereSource.newInstance({
//   radius: 5.0,          // Radius of the sphere
//   thetaResolution: 32,  // Horizontal resolution (number of divisions)
//   phiResolution: 32,    // Vertical resolution (number of divisions)
// });
// const sphereRep = usePolydataRepresentation(view, sphereSource.getOutputData());
// sphereRep.actor.getProperty().setColor(0.0, 0.5, 1.0);  // Set the color to a shade of blue
// sphereRep.actor.setPosition(0, 0, 0);  // Move the sphere to position (10, 5, 0)
// // defineExpose(sphereRep);


// const sphereSource2 = vtkSphereSource.newInstance({
//   radius: 5.0,          // Radius of the sphere
//   thetaResolution: 32,  // Horizontal resolution (number of divisions)
//   phiResolution: 32,    // Vertical resolution (number of divisions)
// });
// const sphereRep2 = usePolydataRepresentation(view, sphereSource2.getOutputData());
// sphereRep2.actor.getProperty().setColor(1.0, 0.5, 1.0);  // Set the color to a shade of blue
// sphereRep2.actor.setPosition(0, 50, 0);  // Move the sphere to position (10, 5, 0)


// const sphereRep3 = usePolydataRepresentation(view, sphereSource2.getOutputData());
// sphereRep3.actor.getProperty().setColor(1.0, 0.5, 1.0);  // Set the color to a shade of blue
// sphereRep3.actor.setPosition(-71, 146, 187);  // Move the sphere to position (10, 5, 0)


defineExpose(polydataRep);
</script>

<template>
  <slot></slot>
</template>
